import { Component, Input, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { IGridResult } from 'src/app/core/models/base';
import { ConnectivityStateService } from 'src/app/shared/services/connectivity-state.service';
import { ProductViewComponent } from 'src/app/products/product-view/product-view.component'
import { CurrentBasketService } from 'src/app/basket/services/current-basket.service';


@Component({
    selector: 'app-home-view',
    templateUrl: './home-view.component.html',
    styleUrls: ['./home-view.component.scss'],
    standalone: false
})
export class HomeViewComponent implements OnInit {
  tabletAndSmaller : boolean = true;
  
  public currentCompany$ = this.currentBasketService.currentCompany$;
  public connectionState$ : Observable<boolean> = this.connectivityStateService.connectionState$;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
  if (event.target.innerWidth < 1400) {
    this.tabletAndSmaller = true;
  } else {
    this.tabletAndSmaller = false;
  }
  }

  constructor(
    private connectivityStateService : ConnectivityStateService,
    private currentBasketService : CurrentBasketService) { }

  ngOnInit(): void {
    if (window.innerWidth < 1400) {
      this.tabletAndSmaller = true;
    } else {
      this.tabletAndSmaller = false;
    }
  }
}
